'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Rules.StrategyConfirmation', []).directive('rmStrategyEditConfirm', require('./directives/StrategyEditConfirmDirective'));